module.exports = __webpack_public_path__ + "img/check_balance_webshop.d27eaca.svg";